import styled from 'styled-components';
import Bg from '@/assets/game-chess/header-bg.png';

export const Wrapper = styled.div`
  overflow: hidden;
  background: url(${Bg});
  background-size: 100% 100%;
  height: 80px;
`;
